/**
 * Lista stacji metra do pełnoekranowego wyboru — kolejność i filtrowanie.
 *
 * DLACZEGO OSOBNY EKRAN, A NIE CHMURA CHIPÓW. 38 stacji pokazanych naraz w nakładce
 * obszaru zepchnęło dzielnice poza ekran (decyzja Piotra 26.09) i dlatego stacje żyją
 * w kontekście dzielnicy. Zostało pytanie, na które kontekst dzielnicy nie odpowiada:
 * „mieszkam przy Kabatach" — człowiek zna NAZWĘ stacji, a nie to, w której dzielnicy
 * ona leży (Ursynów? Kabaty to nazwa i osiedla, i stacji). Pełny spis alfabetyczny na
 * osobnym ekranie odpowiada na nie wprost i nie zabiera miejsca nikomu, kto go nie
 * otworzy.
 *
 * KOLEJNOŚĆ ALFABETYCZNA PO POLSKU, przez `Intl.Collator('pl')`, nie przez zwykłe
 * porównanie napisów: domyślnie „Świętokrzyska" i „Żoliborz" lądują po wszystkich innych
 * literach, bo sortowanie idzie po kodzie znaku. W polskiej kolacji Ś siedzi zaraz za S
 * i to jest miejsce, w którym człowiek jej szuka.
 *
 * FILTR CZYTA TRZY RZECZY: nazwę stacji, dzielnicę i symbol linii. Wpisanie „m2" ma
 * pokazać drugą linię, a „ursynów" — stacje na Ursynowie; obie rzeczy są w danych, więc
 * nie ma powodu udawać, że pole wyszukuje wyłącznie po nazwie.
 */
import { WARSAW_METRO, type MetroStation } from '@/data/warsawMetro';
import { WARSAW_METRO_DISTRICT } from '@/data/warsawMetroDistricts';
import { WARSAW_METRO_LINES, type LiniaMetra } from '@/data/warsawMetroLines';
import { foldPolish } from './areaSearch';

export interface StacjaNaLiscie extends MetroStation {
  linie: LiniaMetra[];
  dzielnica: string | null;
}

const kolacja = new Intl.Collator('pl');

export function stacjeAlfabetycznie(): StacjaNaLiscie[] {
  return WARSAW_METRO.map((s) => ({
    ...s,
    linie: WARSAW_METRO_LINES[s.name] ?? [],
    dzielnica: WARSAW_METRO_DISTRICT[s.name] ?? null,
  })).sort((a, b) => kolacja.compare(a.name, b.name));
}

export function filtrujStacje(stacje: StacjaNaLiscie[], zapytanie: string): StacjaNaLiscie[] {
  const q = foldPolish(zapytanie.trim());
  if (!q) return stacje;
  return stacje.filter((s) => {
    const pola = [s.name, s.dzielnica ?? '', ...s.linie].map(foldPolish);
    return pola.some((p) => p.includes(q));
  });
}
